import DOMPurify from "dompurify";
import { SELECTORS } from "./constants";

// Scrolls the chat container to the bottom after a new message is added
function scrollToBottom(wrapper) {
  const animateContainer = wrapper.closest(
    ".mobius-dialogue-modal__description.mobius-dialogue-modal__description_drawer",
  );
  const chatContainer = animateContainer?.querySelector(
    ".mobius-dialogue-modal__styled-drawer-content",
  );

  if (animateContainer && chatContainer) {
    animateContainer.scrollTo({
      top: chatContainer.scrollHeight,
      behavior: "smooth",
    });
  }
}

// Displays a message in the chat UI, either from the agent or the user
// `type` can be "agent", "user", "error, or "info"
export function displayMessage(wrapper, message, type) {
  const msgsElem = wrapper.querySelector(SELECTORS.MESSAGES_ELEMENT);
  msgsElem.insertAdjacentHTML("beforeend", DOMPurify.sanitize(
    `<div class="reco-chat-message chat-message-${type}">${message}</div><div class="clearfix"></div>`,
  ));
  scrollToBottom(wrapper);
}

// Displays a 'consultant unavailable' message in the chat UI
export function displayAgentUnavailable(wrapper) {
  const msgsElem = wrapper.querySelector(SELECTORS.MESSAGES_ELEMENT);
  msgsElem.insertAdjacentHTML("beforeend", DOMPurify.sanitize(
    `<div class="reco-chat-message">
      <div class="chat-message-agent-unavailable">
        Consultant unavailable
      </div>
      <div class="chat-message-agent-unavailable-information">
        There are no consultants available right now.
        <br>
        Please, call us on +44 1604 279528 to speak with someone right away or try again later.
      </div>
    </div><div class="clearfix"></div>`,
  ));
  scrollToBottom(wrapper);
}

// Manages UI state whilst waiting for a response; disables input and shows loader animation
export function setSendingState(wrapper, isSending, showLiveChatPrompt = false) {
  setInputState(wrapper, !isSending);
  setAiLoaderState(wrapper, isSending);

  if (isSending) {
    setChatbotPromptsState(wrapper, false);
    setLiveChatPromptState(wrapper, false);
  } else {
    if (showLiveChatPrompt) {
      setLiveChatPromptState(wrapper, true);
    } else {
      setChatbotPromptsState(wrapper, true);
    }
  }
}

// Enables/disables the chat input and send button
export function setInputState(wrapper, enabled = true) {
  const chatInput = wrapper.querySelector(SELECTORS.CHAT_INPUT);
  const sendButton = wrapper.querySelector(SELECTORS.SEND_BUTTON);

  chatInput.disabled = !enabled;
  if (sendButton) sendButton.classList[enabled ? "remove" : "add"]("disabled-input");
}

// Shows or hides the AI loader animation
function setAiLoaderState(wrapper, show = true) {
  const loaderElem = wrapper.querySelector(".reco-chat-loader-wrapper");

  if (loaderElem) loaderElem.style.display = show ? "block" : "";
}

// Shows or hides the inline chatbot prompts
export function setChatbotPromptsState(wrapper, show = true) {
  const inlinePrompts = wrapper.querySelector(".reco-chat-prompts-outer");
  if (!inlinePrompts) return;

  inlinePrompts.style.display = show ? "" : "none";
}

// Shows or hides the live chat prompt
export function setLiveChatPromptState(wrapper, show = true) {
  const liveChatPrompt = wrapper.querySelector(".reco-chat-live-chat-prompt");
  if (!liveChatPrompt) return;

  liveChatPrompt.style.display = show ? "" : "none";
}

// Sets the height of the chat input to fit its content
export function setChatInputHeight(input) {
  input.style.height = "0";
  input.style.height = `${input.scrollHeight}px`;
}

// Sends a Snowplow event for tracking user interactions
export function sendEvent(wrapper, action, label, property, value) {
  if (
    window.snowplowHelper &&
    window.snowplowHelper.trackFrontofficeStructEvent &&
    wrapper.dataset.chatSessionId
  ) {
    const site = document.querySelector('meta[name="site"]')?.getAttribute("content") || "";

    window.snowplowHelper.trackFrontofficeStructEvent({
      serviceChannelIdentifier: site,
      category: wrapper.dataset.chatSessionId,
      action,
      label,
      property,
      value
    });
  }
}

export function sendMessageSentEvent(wrapper, message, actor) {
  if (
    window.snowplowHelper &&
    window.snowplowHelper.trackFrontofficeStructEvent &&
    wrapper.dataset.chatSessionId
  ) {
    const chatInput = wrapper.querySelector(SELECTORS.CHAT_INPUT);
    const { insProduct } = chatInput.dataset;

    const site = document.querySelector('meta[name="site"]')?.getAttribute("content") || "";
    const pageTitle = document.querySelector('title')?.textContent || null;
    const payload = {
      page_title: pageTitle,
      chat_session_id: wrapper.dataset.chatSessionId,
      product: insProduct || null,
      message,
      actor,
    }

    window.snowplowHelper.trackUnstructEvent(
      "iglu:com.simplybusiness/ia_live_chat_message_sent/jsonschema/1-0-0",
      payload,
      window.snowplowHelper.distributionChannelContext({
        version: "1-0-0",
        serviceChannelIdentifier: site,
      })
    );
  }
}
